<!--
    description： 组织架构 - 组织管理 - 添加用户
-->
<template>
  <IviewModal
    :title="ppType === 'add' ? '添加角色' : '编辑角色'"
    @on-ok="save"
    @on-cancel="close"
    size="large"
    class="iviewModal"
    v-bind="$attrs"
    @on-visible-change="open"
  >
    <div class="node-content">
      <Form ref="form" :model="form" :rules="rules">
        <FormItem prop="name" label="角色名称:" required>
          <IviewInput v-model="form.name"></IviewInput>
        </FormItem>

        <FormItem :label="'设置用户:'">
          <div class="setUser">
            <div v-for="(item, index) in form.userList" :key="index">
              {{ item }}
            </div>
            <div class="active" @click="setUserOpen">设置用户</div>
          </div>
        </FormItem>
        <FormItem label="管理范围:" prop="parentManageRange">
          <div class="vertical">
            <IviewRadioGroup v-model="form.parentManageRange" :radioList="scopeSelect" vertical />
            <div class="tree-wrap" v-show="form.parentManageRange == '1'">
              <Tree :data="organTree" show-checkbox ref="organTree" @on-check-change="organTreeChange"></Tree>
            </div>
          </div>
        </FormItem>
        <FormItem label="选择部门或本人:" prop="dep">
          <div class="dep">
            <el-radio-group v-model="form.scope" size="small">
              <el-radio-button label="按部门">按部门</el-radio-button>
              <el-radio-button label="仅本人">仅本人</el-radio-button>
            </el-radio-group>
            <div class="tip">将根据管理范围中所选的组织内配置</div>
            <div class="dep-radio" v-if="form.scope == '按部门'">
              <IviewRadioGroup v-model="form.manageRange" :radioList="depList" vertical />
            </div>
            <div class="tree-wrap" v-show="form.manageRange == 1">
              <Tree :data="depTree" show-checkbox ref="depTree"></Tree>
            </div>
          </div>
        </FormItem>
        <FormItem label="功能权限:" prop="selectArr">
          <div>
            <div class="select-per">
              <IviewCheckbox :value="selectArr.length >= moduleList.length" @on-change="allChange">全部</IviewCheckbox>
              <IviewCheckboxGroup @on-change="moduleChange" v-model="selectArr" :optionList="moduleList" />
            </div>
            <div class="model-wrap">
              <div class="top">
                <el-radio-group v-model="form.currentModule" size="small">
                  <el-radio-button
                    v-show="selectArr.includes(item.label)"
                    v-for="(item, i) in rootModuleList"
                    :key="i"
                    :label="item.label"
                    >{{ item.label }}</el-radio-button
                  >
                </el-radio-group>
                <div class="line"></div>
                <IviewCheckboxGroup v-model="form.ptArr" :optionList="treeData" />
                <div class="right" v-if="isRelation">
                  <IviewCheckbox v-model="form.isAccos">权限关联</IviewCheckbox>
                  <el-tooltip popper-class="tooltip-auto">
                    <div slot="content">
                      若勾选权限关联,此后将同步对各端权限的操作
                      <br />若需要单独配置权限,则只需取消勾选
                    </div>
                    <img src="~_img/common/doubt.png" alt="" />
                  </el-tooltip>
                </div>
              </div>
              <ul class="tree-list">
                <li v-for="(item, i) in treeData" :key="item.label" v-show="form.ptArr.includes(item.label)">
                  <div class="t1">{{ item.label }}</div>
                  <div v-for="(tree, k) in item.tree" :key="k">
                    <IviewTree2
                      v-show="form.currentModule == tree.title"
                      v-model="tree.treeCode"
                      :treeData="[tree]"
                      ref="tree"
                      @change="(data) => assocChange(data, i, tree.title)"
                    />
                  </div>
                  <div v-if="!item.tree.find((item) => item.title == form.currentModule)" class="no-tree">暂无数据</div>
                </li>
              </ul>
            </div>
          </div>
        </FormItem>
      </Form>
    </div>

    <!-- 设置用户 -->
    <setUser v-model="setUser.visible" :confObj="config" @confirm="setUserconfirm" ref="setUser"></setUser>
  </IviewModal>
</template>

<script>
import setUser from './setUser.vue'
import { loginMethod, filterTree } from '@/utils/common'
import { getRules } from '@/utils/check'
import { transitionData, transData } from '@/utils'
export default {
  name: 'addRoleUser',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    ppType: {
      type: String,
      default: 'add'
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  components: { setUser },
  data() {
    return {
      scopeSelect: [],
      depList: [
        { label: '全部部门', tip: '（所选组织的全部部门）', value: 3 },
        { label: '归属部门和下级部门', tip: '（该角色所工作的部门及全部下级部门）', value: 2 },
        { label: '归属部门', tip: '（该角色所工作的部门）', value: 4 },
        { label: '指定部门', tip: '（所选组织中的指定部门）', value: 1 }
      ],
      form: {
        model: [],
        model2: '模块1',
        treeCode: [],
        tree: [],
        scope: '按部门',
        manageRange: '',
        parentManageRange: '',
        orgLevel: 1,
        isAccos: true,
        currentModule: '',
        ptArr: this.$root.permissionTree?.map((item) => item.name)
      },
      // config: {},
      keys: [],
      setUser: {
        visible: false,
        isActive: false
      },
      selectArr: [],
      organTree: [],
      organCode: [],
      depCode: [],
      depTree: [],
      moduleList: [],
      rootModuleList: this.$root.permissionModules || [],
      permissionTree: this.$root.permissionTree || [],
      treeData: [],
      isRelation: false,
      rules: {
        ...getRules([
          { label: '角色名称', key: 'name' },
          { label: '管理范围', key: 'parentManageRange', type: 'number', radio: true }
        ]),
        dep: [
          {
            required: true,
            validator: (rule, value, callback, source, options) => {
              if (this.form.scope == '按部门' && !this.form.manageRange) {
                callback('请选择部门')
              }
              callback()
            }
          }
        ],
        selectArr: [
          {
            required: true,
            validator: (rule, value, callback, source, options) => {
              if (this.selectArr.length == 0) {
                callback('请至少分配一个模块')
              }
              callback()
            }
          }
        ]
      }
    }
  },
  async created() {
    // let bool = await loginMethod()
    // if (!bool) {
    //   this.permissionTree = filterTree()
    // }
    // let timer = setInterval(() => {
    //   let data = JSON.parse(localStorage.getItem('roleConfig'))
    //   if (data) {
    //     this.config = data
    //     this.init()
    //     clearInterval(timer)
    //   }
    // }, 50)
    // 是否可以权限关联
    this.$api.config.getNodePermission().then((res) => {
      this.isRelation = Boolean(res.data.relationFlag)
    })
  },
  watch: {
    config: {
      handler(n) {
        n?.groupId && this.init();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init() {
      if (this.data?.userDisplayName) {
        this.form.userList = this.data.userDisplayName.split(',')
      }
      // this.config = JSON.parse(localStorage.getItem('roleConfig'))
      this.$api.config.getNode().then((res) => {
        if (this.config.orgLevel == res.data.length) {
          this.scopeSelect = [
            { label: '归属组织', tip: '（该角色所工作的组织）', value: 4 },
            { label: '指定组织', tip: '（可指定所选节点"含全部下级节点"的全部组织）', value: 1 }
          ]
        } else {
          this.scopeSelect = [
            { label: '归属组织及全部下级组织', tip: '（该角色所工作的组织及全部下级组织）', value: 2 },
            { label: '归属组织和下级组织', tip: '（该角色所工作的组织及下一级组织）', value: 3 },
            { label: '归属组织', tip: '（该角色所工作的组织）', value: 4 },
            { label: '指定组织', tip: '（可指定所选节点"含全部下级节点"的全部组织）', value: 1 }
          ]
        }
        this.getOrganTree()
        this.getModuleList() //获取模块复选框
        this.getDefaultCode()
      })
    },
    // 关联权限改变时
    assocChange(data, i1, module) {
      if (this.form.isAccos) {
        if (i1 != 0) {
          data = data.map((item) => item.slice(0, item.length - 2))
        }
        this.treeData.map((item, i) => {
          if (i != i1) {
            let arr = i == 0 ? data : data.map((item) => item + '_' + i)
            let currentModule = item.tree.find((tree) => tree.title == module)
            if (currentModule) {
              currentModule.treeCode.push(...arr)
            }
          }
        })
      }
    },
    open(bool) {
      if (bool) {
        if (this.ppType == 'edit') {
          this.form = { ...this.form, ...this.data, scope: this.data.manageRange == 0 ? '仅本人' : '按部门' }
          this.$api.config.getRoleAttrs({}, [this.data.id]).then((res) => {
            if (res.data[0]) {
              this.selectArr = JSON.parse(res.data[0].attributeContent)
            } else {
              this.selectArr = []
            }
            if (res.data[1]) {
              this.form.isAccos = Boolean(+res.data[1].attributeContent)
            } else {
              this.form.isAccos = false
            }
          })
          // 获取能配置的权限码,以及回显
          this.getDefaultCode()
          // 指定组织数据回显
          this.$api.role.getRoleDetail({}, [this.data.id]).then((res) => {
            this.organCode = res.data.filter((item) => item.manageRangeType == 1).map((item) => item.groupId)
            this.depCode = res.data.filter((item) => item.manageRangeType == 2).map((item) => item.groupId)
            this.defaultTreeData()
            this.organTreeChange()
          })
          if (!this.form.currentModule && this.moduleList.length > 0) {
            this.form.currentModule = this.moduleList[0].value
          }
        } else {
          this.selectArr = this.moduleList.map(item => item.label)
          this.form.currentModule = this.selectArr[0]
        }
      } else {
        // 初始化
        this.form = {
          model: [],
          model2: '模块1',
          treeCode: [],
          tree: [],
          scope: '按部门',
          manageRange: '',
          parentManageRange: '',
          orgLevel: 1,
          isAccos: false,
          ptArr: this.form.ptArr,
          currentModule: ''
        }
        this.selectArr = []
        this.treeData.map((item) => item.tree.map((item2) => (item2.treeCode = [])))
        this.organCode = []
        this.treeCode = []
        this.defaultTreeData()
        this.defaultDepData()
        this.$refs.form.resetFields()
      }
    },
    organTreeChange() {
      let selectNode = this.$refs.organTree.getCheckedNodes()
      let codes = selectNode.map((item) => item.code).join(',')
      this.$api.role.getDepTree2({ groupId: codes, groupType: 2 }, ['1']).then((res) => {
        this.depTree = transData(res.data, 'children', (item) => {
          return {
            title: item.title,
            code: item.id,
            expand: true,
            disabled: item.groupType == 1
          }
        })
        this.defaultDepData()
      })
      // let arr = selectNode.map(async (item) => {
      //   let res = await this.$api.role.getDepTree({}, [item.code])
      //   return transData([res.data], 'children', (item) => {
      //     return {
      //       title: item.title,
      //       code: item.id,
      //       expand: true,
      //       disabled: item.groupType == 1
      //     }
      //   })
      // })
      // this.depTree = []
      // Promise.all(arr).then((data) => {
      //   data.map((item) => this.depTree.push(...item))
      //   this.defaultDepData()
      // })
    },
    getOrganTree() {
      this.$api.role.getOrganTree({}, [this.config.groupId]).then((res) => {
        this.organTree = transitionData(res.data, {
          title: 'title',
          code: 'id',
          children: 'children',
          expand: 'add-true'
        })
      })
    },
    moduleChange(list) {
      if (!this.form.currentModule && list.length > 0) {
        this.form.currentModule = list[0]
      } else {
        // 选择后取消重置高亮模块
        !list.includes(this.form.currentModule) ? this.form.currentModule = list[0] || null : ''
      }
    },
    // 获取功能权限模块复选框
    getModuleList() {
      this.$api.config.getNodeAttr({}, [this.config.orgLevel]).then((res) => {
        if (res.data[0]) {
          let data = JSON.parse(res.data[0].attributeContent)
          let obj = {}
          data.map((item) => (obj[item] = true))
          this.moduleList = this.rootModuleList?.filter((item) => obj[item.label])
        } else {
          this.moduleList = []
        }
      })
    },
    // 获取该节点所能配置的权限码
    getDefaultCode() {
      this.$api.config.getNodeAssoc({}, [this.config.orgLevel]).then(async (res) => {
        // 获取角色权限
        let roleCode = []
        if (this.ppType == 'edit') {
          roleCode = await this.$api.role.getRoleCodes({}, [this.data.hierachyId, this.data.id])
        }
        // .then((res) => {
        // this.treeData.map((item) => item.tree.map((item2) => (item2.treeCode = res.data)))
        // })
        this.defaultCode = res.data
        this.treeData = this.permissionTree?.map((item) => {
          let treeData = JSON.parse(JSON.stringify(item.tree))
          let treeList = this.filterDefaultTree(treeData)
          return {
            label: item.name,
            value: item.name,
            tree: treeList.map((tree) => {
              return { ...tree, treeCode: roleCode.data }
            })
          }
        })
      })
    },
    // 依据默认权限过滤出对应的数结构
    filterDefaultTree(data) {
      const list = (arr) => {
        return arr.filter((item) => {
          if (this.defaultCode.includes(item.code)) {
            if (item.children) item.children = list(item.children)
            if (item.childrens) item.childrens = list(item.childrens)
            return true
          } else {
            return false
          }
        })
      }
      return list(data)
    },
    setUserOpen() {
      this.setUser.visible = true
      this.setUser.isActive = true
      this.$refs.setUser.getUser()
      if (this.form.hierachyId || this.form.hierachyId == 0) {
        this.$refs.setUser.getRoleUser([this.form.hierachyId, this.form.id])
      } else {
        this.$refs.setUser.keys = []
      }
    },
    saveTreeCode(hierachyId, id) {
      let codes = []
      this.$refs.tree.map((item) => {
        // 过滤已选择后取消的模块权限码
        if (this.selectArr.includes(item.treeData[0]?.title)) {
          codes.push(...item.getNodes())
        }
      })
      this.$api.role.setRoleCodes(codes, [hierachyId, id])
    },
    // bool是否可以清除用户
    saveUser(data, bool = true) {
      let params = {
        roleUserList: data.roleUserList.map((item) => ({
          roleId: data.roleId,
          userId: item.id,
          userDisplayName: item.displayName,
          groupId: this.config.id
        })),
        groupUserList: data.groupUserList
      }
      if (data.roleUserList.length > 0) {
        this.$api.role.setRole2(params).then((res) => {
          this.$Message.success('操作成功')
          this.$parent.getList();
        })
      } else {
        if (bool) {
          this.$api.role.clearRole2(params, [this.id]).then((res) => {
            this.$Message.success('操作成功')
            this.$parent.getList();
          })
        }
      }
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let params = {
            name: this.form.name,
            parentManageRange: this.form.parentManageRange,
            manageRange: this.form.scope == '仅本人' ? 0 : this.form.manageRange,
            roleAttributeVos: [
              { type: 1, attributeContent: JSON.stringify(this.selectArr) },
              {
                type: 2,
                attributeContent: +this.form.isAccos
              }
            ],
            enable: true,
            roleType: 1
          }
          // 选择特定组织
          if (this.form.parentManageRange == 1) {
            let selectNode = this.$refs.organTree.getCheckedNodes()
            params.parentGroups = selectNode.map((item) => ({
              groupId: item.code,
              manageRange: 4,
              manageRangeType: 1,
              relationType: 2
            }))
          }
          // 选择特定部门
          if (this.form.manageRange == 1) {
            let selectNode = this.$refs.depTree.getCheckedNodes()
            params.groups = selectNode.map((item) => ({
              groupId: item.code,
              manageRange: 4,
              manageRangeType: 2,
              relationType: 2
            }))
          }
          if (!this.setUser.isActive) {
            this.keys = {
              roleUserList: [],
              groupUserList: []
            }
          } else {
            this.setUser.isActive = false
          }
          let id = this.config.id
          if (this.ppType == 'add') {
            this.$api.role.addRole(params, [id]).then((res) => {
              this.$emit('refresh')
              this.$Message.success('添加成功')
              // 给角色设置用户
              if (this.keys.roleUserList?.length > 0) {
                this.keys.roleId = res.data.id
                this.saveUser(this.keys)
              }
              // 给角色设置权限
              this.saveTreeCode(res.data.hierachyId, res.data.id)
              this.close()
            })
          } else {
            //编辑
            this.$api.role
              .putRole({ ...this.data, ...params }, [this.config.groupId, this.data.hierachyId, this.data.id])
              .then(async (res) => {
                this.$emit('refresh')
                // 给角色设置权限
                this.saveTreeCode(res.data.hierachyId, res.data.id)
                // 给角色设置用户
                this.keys.roleId = res.data.id
                this.saveUser(
                  this.keys,
                  false
                )
                this.$Message.success('编辑成功')
                this.close()
              })
          }
        }
      })
    },
    setUserconfirm(data) {
      this.keys = data
      this.setUser.visible = false
      this.form.userList = data.roleUserList.map((item) => item.displayName)
    },
    close() {
      this.$emit('input', false)
    },
    // 勾选树数据
    defaultTreeData(data = this.organTree) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
          this.defaultTreeData(data[i].children)
        }
        if (this.organCode.includes(data[i].code)) {
          this.$set(data[i], 'checked', true)
        } else {
          this.$set(data[i], 'checked', false)
        }
      }
    },
    allChange(bool) {
      if (bool) {
        this.selectArr = this.moduleList?.map((item) => item.label)
        if (!this.form.currentModule && this.selectArr.length > 0) {
          this.form.currentModule = this.selectArr[0]
        }
      } else {
        this.selectArr = []
      }
    },
    defaultDepData(data = this.depTree) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
          this.defaultDepData(data[i].children)
        }
        if (this.depCode.includes(data[i].code)) {
          this.$set(data[i], 'checked', true)
        } else {
          this.$set(data[i], 'checked', false)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.ivu-form {
  .ivu-form-item-error-tip {
    margin-left: 110px;
  }
  .ivu-form-item-label {
    width: 110px;
  }
}
</style>
<style lang="less" scoped>
.iviewModal {
  .setUser {
    display: flex;
    align-items: center;
    height: 30px;
    > div {
      // width: 70px;
      padding: 0 10px;
      height: 24px;
      background: #ebeff4;
      border-radius: 4px;
      border: 1px solid transparent;
      margin-right: 10px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
      line-height: 24px;
      text-align: center;
      &.active {
        border: 1px solid var(--theme-color);
        background: #fff;
        color: var(--theme-color);
        cursor: pointer;
        padding: 0 20px;
      }
    }
  }
  .node-content {
    padding-bottom: 30px;
    .tree-wrap {
      margin: 6px 110px 0;
      background: #f6f8fb;
      border: 1px solid #e9edf2;
      padding: 10px;
      height: 230px;
      overflow-y: auto;
      overflow-x: hidden;
      width: 450px;
    }
    .dep {
      position: relative;
      flex: 1;
      .tip {
        position: absolute;
        left: 270px;
        top: 0px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f2b50d;
      }
      .dep-radio {
        margin: 6px 0 0 110px;
      }
    }
    .select-per {
      min-height: 20px;
      display: flex;
      align-items: center;
    }
    .model-wrap {
      background: #f6f8fb;
      margin: 20px 0 0;
      padding-bottom: 10px;
      .top {
        height: 64px;
        background: #ffffff;
        box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.03);
        border-radius: 2px 2px 0px 0px;
        border: 1px solid #e9edf2;
        display: flex;
        align-items: center;
        padding: 0 30px;
        position: relative;
        .line {
          width: 1px;
          height: 20px;
          background: #d7dfee;
          margin: 0 16px;
        }
        .right {
          display: flex;
          align-items: center;
          position: absolute;
          right: 14px;
        }
      }
      .tree-list {
        margin: 12px 15px;
        display: flex;
        width: 1190px;
        li {
          background: #fff;
          flex: 1;
          margin: 0 6px;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
          border-radius: 2px;
          position: relative;
          .t1 {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #e8ebf1;
            font-size: 14px;
            font-family: Helvetica;
            color: #333333;
            padding-left: 20px;
          }
          .i-tree {
            padding: 20px 10px;
          }
          .no-tree {
            padding: 10px;
            // position: absolute;
            // left: 0;
            // right: 0;
            // top: 40px;
            // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
          }
        }
      }
    }
  }
}
/deep/ .ivu-tree-title {
  width: calc(100% - 30px);
  /*height: 30px;*/
  font-size: 14px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  color: #2c3542;
  background: transparent;
  > span {
    height: 30px;
    display: inline-flex !important;
    align-items: center;
    justify-content: space-between;
  }

  &:hover {
    background: transparent;
  }
}
</style>
